import { register } from '@shopify/theme-sections'
import '../../styles/sections/index-articles-row.scss'
import 'slick-carousel'
import $ from 'jquery'

export default register(`index-articles-row`, {
  onLoad() {
    $(`.articles-row__fcm .slick-slider`).each(function() {
      $(this).slick()
    })
  },
  onUnload() {},
})